// RAF-driven count-up with a cubic ease-out (the birthday-campaign pill
// pattern) — drives the reward reveal's currency pills. Rounds to whole
// numbers each frame (the pills only ever show integers). A delta <= 0 is a
// no-op. Returns a cancel function so an unmounting caller can stop the loop.
export function animateCount(opts: {
  from: number
  delta: number
  duration?: number
  onTick: (value: number) => void
}): () => void {
  const { from, delta, duration = 700, onTick } = opts
  if (delta <= 0) return () => {}
  const to = from + delta
  const start = performance.now()
  let raf = 0
  const tick = (now: number) => {
    const t = Math.min(1, (now - start) / duration)
    const eased = 1 - Math.pow(1 - t, 3)
    onTick(Math.round(from + (to - from) * eased))
    if (t < 1) raf = requestAnimationFrame(tick)
  }
  raf = requestAnimationFrame(tick)
  return () => cancelAnimationFrame(raf)
}
